/*
Akhila 12/26/2022 3075154998 Added Add Rule Popup
Prakash 01/16/2023 3075154998 Fixed Responsiveness issues.
Ravi 02/10/2023 3075154998 Rename placeholder in Operators and Fields.
Prakash 03/29/2023 3075154998 Added margin spacings.
*/
import {Button, withStyles} from '@material-ui/core';
import {Autocomplete} from '@mui/material';
import React, {useContext} from 'react';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
const DefaultOpenAutoComplete = withStyles({
  popperDisablePortal: {
    // position: "relative !important",
  },
})(Autocomplete);
const DMRaddRuleSelectFields = ({
  label,
  options = [],
  optionLable,
  groupBy,
  value,
  name,
  renderOption,
  handleChange,
  handleInsert,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  return (
    <div className="global-field-textfields add-calculation-rule new-standard-textfields mt-md-2 mt-lg-0 col-md-6 col-xl-3 col-lg-4">
      <DefaultOpenAutoComplete
        classes={{
          option: classes.option,
        }}
        size="small"
        value={value}
        name="function"
        options={options ? options : []}
        groupBy={groupBy}
        getOptionLabel={optionLable}
        onChange={handleChange}
        fullWidth
        open={true}
        disablePortal
        renderOption={renderOption}
        autoSelect={false}
        ListboxProps={{
          style: {
            maxHeight: '130px',
          },
        }}
        renderInput={(params) => (
          <div className="select-field">
            <GuiTextField
              {...params}
              className={`${classes.labelName}`}
              variant="outlined"
              margin="dense"
              InputLabelProps={{
                shrink: true,
              }}
              label={label}
              placeholder={`Select ${label}`}
            />
          </div>
        )}
      />
      <Button
        variant="outlined"
        onClick={handleInsert}
        className={`reset-btn ml-1 mb-2 ${classes.buttonRoot} box-btn`}
      >
        Insert
      </Button>
    </div>
  );
};

export default DMRaddRuleSelectFields;
